import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../i18n/globalTranslations';

export const fieldTypeLabel = {
  BILLING_IS_COMPANY: 'billingIsCompany',
  CAMPAIGN_CODE: 'campaignCode',
  CITY: 'city',
  COMPANY: 'company',
  COUNTRY: 'country',
  DELIVERY_ADDRESS_DROPDOWN: 'deliveryAddressId',
  DELIVERY_CARE_OF: 'deliveryCareOf',
  DELIVERY_CITY: 'deliveryCity',
  DELIVERY_COMPANY: 'deliveryCompany',
  DELIVERY_COUNTRY: 'deliveryCountry',
  DELIVERY_IS_COMPANY: 'deliveryIsCompany',
  DELIVERY_NAME: 'deliveryName',
  DELIVERY_PHONE: 'deliveryTelephone',
  DELIVERY_POSTAL_CODE: 'deliveryPostalCode',
  DELIVERY_STREET_ADDRESS: 'deliveryStreetAddress',
  EMAIL: 'email',
  EXTRA_MESSAGE: 'message',
  FIRSTNAME: 'firstName',
  LASTNAME: 'lastName',
  NAME: 'name',
  PHONE: 'telephone',
  POSTAL_CODE: 'postalCode',
  PRIVACY_STATEMENT: 'privacyStatement',
  REGISTER_VISITOR_CUSTOMER: 'registerVisitorCustomer',
  SEPARATE_DELIVERY_ADDRESS: 'useDeliveryAddress',
  STREET_ADDRESS: 'streetAddress',
  VAT_NUMBER: 'businessId',
};

export const labels = {
  allowUnderDelivery: (
    <FormattedMessage {...globalTranslations.allowPartialDeliverySentence} />
  ),
  allowShippingMethodChange: (
    <FormattedMessage {...globalTranslations.allowShippingChangeSentence} />
  ),
  billingIsCompany: (
    <FormattedMessage {...globalTranslations.isCorporateCustomerSentence} />
  ),
  businessId: <FormattedMessage {...globalTranslations.businessIdTitle} />,
  campaignCode: <FormattedMessage {...globalTranslations.campaignCodeLabel} />,
  city: <FormattedMessage {...globalTranslations.cityTitle} />,
  company: <FormattedMessage {...globalTranslations.companyTitle} />,
  companyFirstName: (
    <FormattedMessage {...globalTranslations.contactPersonFirstNameTitle} />
  ),
  companyLastName: (
    <FormattedMessage {...globalTranslations.contactPersonLastNameTitle} />
  ),
  companyContactPerson: (
    <FormattedMessage
      id="checkout.deliveryForm.companyContactPerson"
      defaultMessage="A business customer"
    />
  ),
  companyIndividual: (
    <FormattedMessage
      id="checkout.deliveryForm.individual"
      defaultMessage="An individual"
    />
  ),
  confirmPassword: (
    <FormattedMessage {...globalTranslations.confirmPasswordTitle} />
  ),
  country: <FormattedMessage {...globalTranslations.countryTitle} />,
  deliveryAddressId: (
    <FormattedMessage
      id="recurringOrder.deliveryAddressSentence"
      defaultMessage="Delivery address"
    />
  ),
  deliveryCareOf: <FormattedMessage {...globalTranslations.careOfTitle} />,
  deliveryCity: <FormattedMessage {...globalTranslations.cityTitle} />,
  deliveryCompany: <FormattedMessage {...globalTranslations.companyTitle} />,
  deliveryCountry: <FormattedMessage {...globalTranslations.countryTitle} />,
  deliveryIsCompany: (
    <FormattedMessage {...globalTranslations.isCorporateCustomerSentence} />
  ),
  deliveryName: <FormattedMessage {...globalTranslations.fullNameTitle} />,
  deliveryPostalCode: <FormattedMessage {...globalTranslations.zipCodeTitle} />,
  deliveryStreetAddress: (
    <FormattedMessage {...globalTranslations.streetAddressTitle} />
  ),
  deliveryTelephone: (
    <FormattedMessage {...globalTranslations.telephoneTitle} />
  ),
  email: <FormattedMessage {...globalTranslations.emailTitle} />,
  firstName: <FormattedMessage {...globalTranslations.firstNameTitle} />,
  isCompany: (
    <FormattedMessage {...globalTranslations.isCorporateCustomerSentence} />
  ),
  lastName: <FormattedMessage {...globalTranslations.lastNameTitle} />,
  name: <FormattedMessage {...globalTranslations.fullNameTitle} />,
  newsletter: (
    <FormattedMessage {...globalTranslations.newsletterSubscriptionSentence} />
  ),
  no: <FormattedMessage {...globalTranslations.noTitle} />,
  onHoldUntil: (
    <FormattedMessage
      id="recurringOrder.onHoldTitle"
      defaultMessage="Set subscription on hold until (Use dropdown or calendar icon)"
    />
  ),
  onHoldUntilPlaceHolder: (
    <FormattedMessage
      id="recurringOrder.onHoldPlaceholder"
      defaultMessage="Choose date from calendar"
    />
  ),
  password: <FormattedMessage {...globalTranslations.passwordTitle} />,
  postalCode: <FormattedMessage {...globalTranslations.zipCodeTitle} />,
  privacyStatement: (
    <FormattedMessage {...globalTranslations.privacyStatementAcceptSentence} />
  ),
  reference: <FormattedMessage {...globalTranslations.yourReferenceTitle} />,
  registerVisitorCustomer: (
    <FormattedMessage {...globalTranslations.registerVisitorCustomerTitle} />
  ),
  shippingMethodId: (
    <FormattedMessage
      id="recurringOrder.shippingMethodSentence"
      defaultMessage="Subscription shipping method"
    />
  ),
  status: (
    <FormattedMessage id="global.active" defaultMessage="Active subscription" />
  ),
  streetAddress: (
    <FormattedMessage {...globalTranslations.streetAddressTitle} />
  ),
  telephone: <FormattedMessage {...globalTranslations.telephoneTitle} />,
  title: (
    <FormattedMessage
      id="recurringOrder.titleSentence"
      defaultMessage="Give descriptive title"
    />
  ),
  useDeliveryAddress: (
    <FormattedMessage {...globalTranslations.useDeliveryAddressTitle} />
  ),
  username: <FormattedMessage {...globalTranslations.emailOrUsernameTitle} />,
  yes: <FormattedMessage {...globalTranslations.yesTitle} />,
  addCareOf: <FormattedMessage {...globalTranslations.addCareOfTitle} />,
};
